const normalizePhoneNumber = (input) => {
  let number = input.replace(/\s/g, ''); // remove all spaces
  number = number.replace(/^(\+91|0)/, ''); // remove +91 or leading 0

  if (number.length > 10) {
    number = number.slice(0, 10); // trim to 10 digits
  }

  return number;
};


export default normalizePhoneNumber;